import type { FC, JSX, ReactNode, MouseEventHandler } from 'react';
import { Card, CardHeader, CardContent, Typography } from '@mui/material';

interface InfoCardProps {
	title: string;
	header?: JSX.Element;
	children: ReactNode;
	onClick?: MouseEventHandler<HTMLDivElement>;
}

const InfoCard: FC<InfoCardProps> = ({ header, title, children }) => {
	const sx = { color: 'grey.800' };

	if (header) {
		return (
			<Card variant="outlined">
				<CardHeader subheader={<Typography variant="h6">{title}</Typography>} title={header} sx={sx} />
				<CardContent>{children}</CardContent>
			</Card>
		);
	}

	return (
		<Card variant="outlined">
			<CardHeader title={title} sx={sx} />
			<CardContent>{children}</CardContent>
		</Card>
	);
};

export default InfoCard;
